// extracted by mini-css-extract-plugin
export default {"bottom":"PageBody_bottom__8nLX6","headerAndChildren":"PageBody_headerAndChildren__v51L3","top":"PageBody_top__qr6kD"};